import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { registerUserApi } from "../../end-points/registration";


const initialState = {
  loading: false,
  error: null,
  success: false,
};

export const registerUser = createAsyncThunk(
  "registration/registerUser",
  async(payload, thunkAPI) => {
    try {
      const response = await registerUserApi(payload);
      console.log("response", response);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    resetRegistration: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(registerUser.pending, (state) => {
      console.log("Loading...", state);
      state.loading = true;
    })
    builder.addCase(registerUser.fulfilled, (state, action) => {
      state.loading = false;
      if(action.payload.message === "User registered successfully!"){
        state.success = true;
        state.error = null;
      }
      state.message = action.payload.message;
    })
    builder.addCase(registerUser.rejected, (state, action) => {
      console.log("Error", state, action);
      state.loading = false;
    })
  }
});

export const { resetRegistration } = registrationSlice.actions;
export default registrationSlice.reducer;